import {ServiceTemplateGeneric} from "./ServiceTemplateGeneric";

export class ServiceTemplateSms extends ServiceTemplateGeneric{

    constructor(organizationId,data) {
        super(organizationId,data,"serviceSmsList","serviceSmsId");
    }
}
